module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"memorizeTitle":"Memorer med tallformer","whatItemTitle":"Hva var nummer","playButton":"Spill","cantRemember":"Jeg husker ikke. Hopp over."},"en":{"memorizeTitle":"Memorize with number shapes","whatItemTitle":"What was item no.","playButton":"Play","cantRemember":"I can\u0027t remember. Skip this."}}')
  delete Component.options._Ctor
}
